// extracted by mini-css-extract-plugin
export default {"image-viewer":"tc8tQ9sU7kY5jR9IxcXu","images-pane":"Yx_ghXYXZWqE6ToxeuDB","project-pane":"MmFjCgb5s9wQKwE2HIRB","project-img":"HaT8DKeyki9Zudd7yg7e"};